<template>
  <div class="status-metric">
    <!-- Icon defaults to `medium` (28px); the design specifies 24px. -->
    <Icon :icon="statusIcon" :color="met ? 'success' : 'error'" :medium="false" />
    <Typography variant="subtitle-1" as="span">{{ statusLabel }}</Typography>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Icon from "@/components/generic/Icon.vue";

export default {
  name: "StatusMetric",
  components: { Typography, Icon },
  props: {
    met: { type: Boolean, default: false },
    metLabel: { type: String, default: "" },
    notMetLabel: { type: String, default: "" },
  },
  computed: {
    statusIcon() {
      return this.met ? "mdi-check-circle" : "mdi-close-circle";
    },
    statusLabel() {
      return this.met ? this.metLabel : this.notMetLabel;
    },
  },
};
</script>

<style scoped>
.status-metric {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
